import { Stack, styled } from '@ltvco/refresh-lib/theme';
import { useSessionEscalation, useSession } from '@ltvco/refresh-lib/v1';
import { useFeatureIsOn } from '@ltvco/refresh-lib/vendors';

import { Loading } from '../Loading';

import { CheckEmail } from './CheckEmail';
import { Summaries } from './Summaries';

const StyledStack = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  alignItems: 'center',
  textAlign: 'center',
  padding: theme.spacing(2, 2.5),
}));

const StyledStackVariation = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  alignItems: 'center',
  textAlign: 'center',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: '12px',
  paddingBottom: theme.spacing(2),
  paddingTop: theme.spacing(2),
  marginTop: '28px',
  '& div': {
    borderRadius: '12px',
    boxShadow: 'none',
  },
}));

export const GettingStarted = () => {
  const { checkEmail } = useSessionEscalation();
  const isInPerksPageVariation = useFeatureIsOn('RFRSH-3131');
  const {
    session: { account },
  } = useSession();

  const isEnrolled =
    account?.account?.user_settings?.credit_hub_enrollment_completed;

  const display = () => {
    if (checkEmail) {
      return <CheckEmail />;
    }

    if (isEnrolled) {
      return <Loading />;
    }

    return <Summaries />;
  };

  return isInPerksPageVariation ? (
    <StyledStackVariation>{display()}</StyledStackVariation>
  ) : (
    <StyledStack>{display()}</StyledStack>
  );
};
